<script setup>
import { computed, ref } from "vue";
import { useCartDataProvider } from "../../hooks/useCartDataProvider";
import IAcquiringsButton from "../IAcquiringsButton/IAcquiringsButton.vue";
import IAcquiringsBulkBuyTeacherButton from "../IAcquiringsBulkBuyTeacherButton/IAcquiringsBulkBuyTeacherButton.vue";
import IModal from "../IModal/IModal.vue";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import ICollectivePurchaseModal from "../ICollectivePurchaseModal/ICollectivePurchaseModal.vue";

translator.getLanguages();
const { isFakePayment } = useCartDataProvider();

const props = defineProps({
	order: {
		type: Object,
		required: true,
	},
	smallBtn: {
		type: Boolean,
		default: false,
	},
});

const getPayUrl = () => {
	if (isFakePayment) return `/order/fake?id=${props.order.id}`;
	return `/pay/pay?id=${props.order.id}`;
};

const firstEventId = computed(() => props.order.cases[0].id);

const eventType = computed(() => props.order.cases[0].type);

const collectivePurchaseModalShow = ref(false);

const ticketsCount = computed(() =>
	props.order.cases.reduce(
		(accumulator, currentEvent) => accumulator + currentEvent.tickets.length,
		0
	)
);

const acquiringsReversed = computed(() => [...props.order.acquirings].reverse());

const isAcquiringError = ref({
	isAcquiringError: false,
	errorMessage: "",
});

function updatePage() {
	window.location.reload();
}

function setAcquiringError(errorObject) {
	isAcquiringError.value = errorObject;
}
const hasMultipleAcquirings = computed(() => props.order.acquirings.length > 1);
const isHistory = !window.location.pathname.includes('/orders/cart');
const activeAcquiring = [...acquiringsReversed.value].filter((acquiring) => acquiring.id === props.order.acquiringId);
</script>

<template>
	<div class="i-acquirings">
		<template v-if="!isHistory">
			<i-acquirings-button
				v-for="acquiring in acquiringsReversed"
				:key="acquiring.id"
				:first-event-id="firstEventId"
				:event-type="eventType"
				:options="{ ...acquiring, orderId: order.id }"
				:small-btn="smallBtn"
				:tickets-count="ticketsCount"
				:url="getPayUrl()"
				@set-acquiring-error="errorState => setAcquiringError(errorState)"
			></i-acquirings-button>
		</template>
    <template v-if="isHistory">
			<i-acquirings-button
      	v-for="acquiring in activeAcquiring"
				:key="activeAcquiring.id"
				:first-event-id="firstEventId"
				:event-type="eventType"
				:options="{ ...acquiring, orderId: order.id }"
				:tickets-count="ticketsCount"
				:url="getPayUrl()"
				@set-acquiring-error="errorState => setAcquiringError(errorState)"
			></i-acquirings-button>
		</template>
		<template v-if="order.bulkBuyTeacherParams">
			<IAcquiringsBulkBuyTeacherButton
				v-if="order.bulkBuyTeacherParams"
				:small-btn="smallBtn"
				:countOrderEvents="order.cases.length"
				:bulkBuyTeacherParams="order.bulkBuyTeacherParams"
				@open-collective-purchase-modal="collectivePurchaseModalShow = true"
			/>
		</template>
	</div>
	<ICollectivePurchaseModal
		v-if="order.bulkBuyTeacherParams"
		v-model="collectivePurchaseModalShow"
		:bulkBuyTeacherParams="order.bulkBuyTeacherParams"
		@close-collective-purchase-modal="collectivePurchaseModalShow = false"
		:order="order"
	/>
	<i-modal v-model="isAcquiringError.isAcquiringError" @hide="updatePage">
		<template #body>
			{{
				isAcquiringError.errorMessage ??
				translator.t("main", "An error occurred when paying for the order!")
			}}
		</template>
	</i-modal>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-acquirings.scss";
</style>
